import React from "react";
import './contactBar.scss';
import Button from "../../../components/ui/button/Button";
import {Link} from "gatsby";
import {useTranslation} from "gatsby-plugin-react-i18next";

const ContactBar = () => {
    const {t} = useTranslation('common');
    return (
        <div className='contactBar'>
            <h2 className='title'>{t('contactBar.title')}</h2>
            <Link to={'/contact'} className='buttonContainer'>
                <Button
                    label={t('contactBar.button')}
                />
            </Link>
        </div>
    );
};

export default ContactBar;